module.exports = __webpack_public_path__ + "media/images/home/rentabilidade-79e1b1ac8c81ff343a9317d6c07ef082.png";